import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { FlagStoreAdmin } from "./FlagStoreAdmin";
import { ExplainUserTab } from "./FlagStorePanels";

export function FeatureFlagsTab() {
  return <Tabs defaultValue="store" className="flex h-full min-h-0 flex-col">
    <TabsList>
      <TabsTrigger value="store">Flag store</TabsTrigger>
      <TabsTrigger value="explain">Explain a user</TabsTrigger>
    </TabsList>
    <TabsContent value="store" className="min-h-0 flex-1">
      <FlagStoreAdmin />
    </TabsContent>
    <TabsContent value="explain" className="min-h-0 flex-1 overflow-auto">
      <ExplainUserTab />
    </TabsContent>
  </Tabs>;
}
